import React, { useState, useEffect } from 'react';
import {
    useNavigate,
    useLocation,
} from "react-router-dom";
import { useSnackbar } from "notistack";

import { Typography } from "@mui/material";
import { SignUpContainer, SignUpStyledCard } from '../../Styles/Authentication/authenticationStyles';

import { IconEye, IconEyeOff } from '@tabler/icons-react';

import { useLoadingScreen } from '../../Store/LoadingManager';

import { useAuthenticationHook } from '../../Hooks/Authentication/authenticationHooks';
import { useCompanyHook } from '../../Hooks/Companies/companyHooks';

import { SignUpUser } from '../../Models/Authentication/Authentication';
import { CompanyList } from '../../Models/Company/Company';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';

import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { ActiveStatusEnum } from '../../Utilities/Enums/StatusEnums';
import { SignUpField, AdminUserProfileField, CompanyListField } from '../../Utilities/Enums/ParametersEnum';
import { AccountType } from '../../Utilities/Enums/RegistrationEnum';

import { AssetImages } from "../../Constants/Assets";
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';
import { ErrorMessage } from '../../Constants/Messages';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import AutoCompleteDropdown from '../../CustomViews/Elements/AutoCompleteDropdown';
import FormTextField from '../../CustomViews/Elements/FormTextField';
import FormReCaptcha from '../../CustomViews/Elements/FormReCaptcha';
import AuthFooter from './AuthFooter';
import ErrorPage from '../../CustomViews/Pages/ErrorPages/ErrorPage';

export default function SignUp() {
    const navigate = useNavigate();
    const location = useLocation();
    let { loading, setLoading } = useLoadingScreen();
    const { DropdownData, dropdownFetchStatus, signUpUser } = useAuthenticationHook();
    const { enqueueSnackbar } = useSnackbar();
    let requiredFields = RequiredParametersHelper.signup();
    let queryParams = new URLSearchParams(location.search);
    let pageId = queryParams.get('registrationCode') != null && queryParams.get('registrationCode') != "" ? queryParams.get('registrationCode') : null;

    //Use States
    let [formData, setformData] = useState<SignUpUser>({...new SignUpUser(), [SignUpField.STATUS]: ActiveStatusEnum.ACTIVE, [SignUpField.ACCOUNT_TYPE]: AccountType.CUSTOMER  });
    let [errorMessages, setErrorMessages]: any = useState({});
    let [showPassword, setShowPassword] = useState(false);
    let [validateRegistrationCode, setvalidateRegistrationCode] = useState(false);
    let [validateVendorRegistrationCode, setvalidateVendorRegistrationCode] = useState(false);


    //Code Validation Purposes
    const [validRegistrationCode, setvalidRegistrationCode] = useState(false);
    const [validVendorRegistrationCode, setvalidVendorRegistrationCode] = useState(false);

    const { getCompanyByRegistrationCode, getCompanyByVendorRegistrationCode } = useCompanyHook(null, [], false);
    ////////////////////////////////////////////////////////////////////

    //Variables
    const registrationCodeProps = {
        name: SignUpField.REGISTRATION_CODE,
        title: 'Registration Code',
        fieldValue: formData?.[SignUpField.REGISTRATION_CODE] ?? "",
        type: 'text',
        fieldClassName: 'span2Item',
        required: requiredFields?.find((field: any) => field.keyName == SignUpField.REGISTRATION_CODE)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {

            setformData((prev: any) => ({
                ...prev,
                [SignUpField.REGISTRATION_CODE]: selectedValue,
            }));

            if(!validateRegistrationCode) {
                setvalidateRegistrationCode(true);
            }
        },
    },
        vendorRegistrationCodeProps = {
            name: SignUpField.VENDOR_REGISTRATION_CODE,
            title: 'Vendor Registration Code',
            fieldValue: formData?.[SignUpField.VENDOR_REGISTRATION_CODE] ?? "",
            type: 'text',
            fieldClassName: 'span2Item',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.VENDOR_REGISTRATION_CODE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {

                setformData((prev: any) => ({
                    ...prev,
                    [SignUpField.VENDOR_REGISTRATION_CODE]: selectedValue,
                }));

                if(!validateVendorRegistrationCode) {
                    setvalidateVendorRegistrationCode(true);
                }
            },
        },
        accountTypeProps = {
            name: SignUpField.ACCOUNT_TYPE,
            title: 'Account Type',
            fieldClassName: 'span2Item',
            fieldValue: formData?.[SignUpField.ACCOUNT_TYPE] ?? "",
            options: DropdownData?.[CachingEnum.ACCOUNT_TYPE_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.ACCOUNT_TYPE)?.keyName != null,
            errorMessages: errorMessages,
            // disabled: !validRegistrationCode,
            disabled: true,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [SignUpField.ACCOUNT_TYPE]: selectedValue?.id ?? null }));
            },
        },
        pocNameProps = {
            name: AdminUserProfileField.NAME,
            title: 'POC Name',
            fieldValue: formData?.[SignUpField.PROFILE]?.[AdminUserProfileField.NAME] ?? "",
            type: 'text',
            fieldClassName: 'span2Item',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.PROFILE)?.fields?.find((f: any) => f.keyName == AdminUserProfileField.NAME)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            handleOnChange: (selectedValue: any) => {
                let _fullName = selectedValue?.split(" ") ?? [];
                let _lastName = _fullName?.length > 1 ? _fullName.pop() : '';
                let _firstName = _fullName?.length <= 1 ? _fullName[0] : _fullName.join(' ');
                
                setformData((prev: any) => ({
                    ...prev,
                    [SignUpField.PROFILE]: {
                        ...prev?.[SignUpField.PROFILE],
                        [AdminUserProfileField.NAME]: selectedValue,
                        [AdminUserProfileField.FIRST_NAME]: _firstName,
                        [AdminUserProfileField.LAST_NAME]: _lastName,
                    },
                }));


            },
        },
        usernameProps = {
            name: SignUpField.USERNAME,
            title: 'Username',
            fieldValue: formData?.[SignUpField.USERNAME] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.USERNAME)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [SignUpField.USERNAME]: selectedValue }));
            },
        },
        passwordProps = {
            name: SignUpField.PASSWORD,
            title: 'Password',
            fieldValue: formData?.[SignUpField.PASSWORD] ?? "",
            type: (showPassword ? 'text' : 'password'),
            hasIcon: true,
            iconPosition: 'end',
            icon: (showPassword ? <IconEyeOff /> : <IconEye />),
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.PASSWORD)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            onClickIconTrigger: () => {
                setShowPassword(!showPassword);
            },
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [SignUpField.PASSWORD]: selectedValue }));
            },
        },
        userEmailProps = {
            name: SignUpField.USER_EMAIL,
            title: 'User Email',
            fieldValue: formData?.[SignUpField.USER_EMAIL] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.USER_EMAIL)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [SignUpField.USER_EMAIL]: selectedValue }));
            },
        },
        userContactNumberProps = {
            name: SignUpField.USER_CONTACT_NUMBER,
            title: 'User Contact Number',
            fieldValue: formData?.[SignUpField.USER_CONTACT_NUMBER] ?? "",
            type: 'number',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.USER_CONTACT_NUMBER)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [SignUpField.USER_CONTACT_NUMBER]: selectedValue }));
            },
        },
        companyProps = {
            name: AdminUserProfileField.COMPANY_PUBLIC_ID,
            title: 'Company',
            fieldClassName: 'span2Item',
            fieldValue: formData?.[SignUpField.PROFILE]?.[AdminUserProfileField.REGISTERED_COMPANY] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.PROFILE)?.fields?.find((f: any) => f.keyName == AdminUserProfileField.COMPANY_PUBLIC_ID)?.keyName != null,
            errorMessages: errorMessages,
            disabled: true,
            handleOnChange: (selectedValue: any) => {
                // setformData((prev: any) => ({ ...prev, [SignUpField.USERNAME]: selectedValue }));
            },
        },
        taxNumberProps = {
            name: AdminUserProfileField.TAX_NO,
            title: 'Tax Number',
            fieldClassName: 'span2Item',
            fieldValue: formData?.[SignUpField.PROFILE]?.[AdminUserProfileField.TAX_NO] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.PROFILE)?.fields?.find((f: any) => f.keyName == AdminUserProfileField.TAX_NO)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({
                    ...prev,
                    [SignUpField.PROFILE]: {
                        ...prev?.[SignUpField.PROFILE],
                        [AdminUserProfileField.TAX_NO]: selectedValue ?? null,
                    },
                }));
            },
        },
        localeProps = {
            name: AdminUserProfileField.CURRENCY_CODE,
            title: 'Locale',
            fieldClassName: 'span2Item',
            fieldValue: formData?.[SignUpField.PROFILE]?.[AdminUserProfileField.CURRENCY_CODE] ?? "",
            options: DropdownData?.[CachingEnum.PRICE_SETTINGS_TAB_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.PROFILE)?.fields?.find((f: any) => f.keyName == AdminUserProfileField.CURRENCY_CODE)?.keyName != null,
            errorMessages: errorMessages,
            disabled: !validRegistrationCode,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({
                    ...prev,
                    [SignUpField.PROFILE]: {
                        ...prev?.[SignUpField.PROFILE],
                        [AdminUserProfileField.CURRENCY_CODE]: selectedValue?.id ?? null,
                    },
                }));
            },
        },
        recaptchaProps = {
            name: SignUpField.RECAPTCHA_KEY,
            required: requiredFields?.find((field: any) => field.keyName == SignUpField.RECAPTCHA_KEY)?.keyName != null,
            errorMessages: errorMessages,
            fieldClassName: 'span2Item',
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [SignUpField.RECAPTCHA_KEY]: selectedValue }));
            },
        };
    
    //Event Handlers
    const registrationCodeValidation = async () => {
        let isValidRegistrationCode: boolean = false;


        if(formData?.[SignUpField.REGISTRATION_CODE] != null && formData?.[SignUpField.REGISTRATION_CODE] != "") {
            let companyDetails = await getCompanyByRegistrationCode(formData?.[SignUpField.REGISTRATION_CODE] ?? null);
            
            isValidRegistrationCode = companyDetails?.data?.PublicId != null && companyDetails?.data?.PublicId != "";

            setformData((prev: any) => ({
                ...prev,
                [SignUpField.PROFILE]: {
                    ...prev?.[SignUpField.PROFILE],
                    [AdminUserProfileField.COMPANY_PUBLIC_ID]: companyDetails?.data?.PublicId ?? null,
                    [AdminUserProfileField.REGISTERED_COMPANY]: companyDetails?.data?.Name ?? null,
                },
            }));
        }
        
        setvalidRegistrationCode(isValidRegistrationCode);

        setErrorMessages((prev: any) => ({
            ...prev, 
            [SignUpField.REGISTRATION_CODE]: (isValidRegistrationCode ? null : ErrorMessage.INVALID + " " + registrationCodeProps.title),
        }));

        setvalidateRegistrationCode(false);
    }

    const vendorRegistrationCodeValidation = async () => {
        let isValidVendorRegistrationCode: boolean = false;


        if(formData?.[SignUpField.VENDOR_REGISTRATION_CODE] != null && formData?.[SignUpField.VENDOR_REGISTRATION_CODE] != "") {
            let companyDetails = await getCompanyByVendorRegistrationCode(formData?.[SignUpField.VENDOR_REGISTRATION_CODE] ?? null);

            isValidVendorRegistrationCode = companyDetails?.data?.PublicId != null && companyDetails?.data?.PublicId != "";
        }

        setformData((prev: any) => ({
            ...prev,
            [SignUpField.ACCOUNT_TYPE]: isValidVendorRegistrationCode ? AccountType.VENDOR : AccountType.CUSTOMER,
        }));
        
        setvalidVendorRegistrationCode(isValidVendorRegistrationCode);

        setErrorMessages((prev: any) => ({
            ...prev, 
            [SignUpField.VENDOR_REGISTRATION_CODE]: (isValidVendorRegistrationCode || (formData?.[SignUpField.VENDOR_REGISTRATION_CODE] == null || formData?.[SignUpField.VENDOR_REGISTRATION_CODE] == "") ? null : ErrorMessage.INVALID + " " + registrationCodeProps.title),
        }));

        setvalidateVendorRegistrationCode(false);
    }
    
    const handleSignUp = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }
        
        let signupResponse = await signUpUser(JSON.stringify(formData));
        let _success: boolean = signupResponse?.isSuccess ?? false;
        
        if(_success) {
            navigate(RouteEnum.LOGIN, { replace: true });
        }
    }

    useEffect(() => {
        if(validateRegistrationCode) {
            registrationCodeValidation();
        }
    }, [validateRegistrationCode]);

    useEffect(() => {
        if(validateVendorRegistrationCode) {
            vendorRegistrationCodeValidation();
        }
    }, [validateVendorRegistrationCode]);

    //Rendering Functions
    const renderSignUpForm = () => {
        return <SignUpContainer className='glossy-box'>
            <div className="suContainer">
                <div className="signUpBgContainer">
                    <SignUpStyledCard elevation={3}>
                        <div className="signUpFormContainer">
                            <div className="formContainer">
                                <img src={AssetImages.WEB_APP_LOGO} />
                                <Typography color="primaryText" className="headerText">Create New Account</Typography>

                                <div className="fieldsContainer">
                                    <FormTextField {...registrationCodeProps} />
                                    <FormTextField {...vendorRegistrationCodeProps} />

                                    <AutoCompleteDropdown {...accountTypeProps} />

                                    <FormTextField {...pocNameProps} />

                                    <FormTextField {...usernameProps} />
                                    <FormTextField {...passwordProps} />

                                    <FormTextField {...userEmailProps} />
                                    <FormTextField {...userContactNumberProps} />

                                    <FormTextField {...companyProps} />

                                    <FormTextField {...taxNumberProps} />

                                    <AutoCompleteDropdown {...localeProps} />

                                    <FormReCaptcha {...recaptchaProps} />
                                </div>

                                <CustomButton
                                    btnType={!validRegistrationCode ? ButtonType.CANCEL : ButtonType.PRIMARY}
                                    title='Sign Up'
                                    className="signUpBtn"
                                    disabled={!validRegistrationCode}
                                    onClick={(e: any) => {
                                        handleSignUp();
                                    }} />

                                <div className="signInContainer">
                                    <span>Already have an account?</span>
                                    <div className="signInLink" onClick={() => { navigate(RouteEnum.LOGIN, { replace: true }); }}>Sign In</div>
                                </div>
                            </div>

                            <div className="spacer2" />
                            
                            <AuthFooter />
                        </div>
                    </SignUpStyledCard>
                </div>
            </div>
        </SignUpContainer>
    }

    return renderSignUpForm();
}